// event name values
export const CLICK_THROUGH_TO_CONTENT = 'Click-through to Content';
export const CLICK_THROUGH_TO_VENDOR_CATEGORY =
	'Click-through to Vendor Category';
export const CLICK_THROUGH_TO_VENDORS = 'Click-through to Vendors';
export const VENDOR_SEARCH_INTERACTION = 'Vendor Search Interaction';
export const WIDGET_VIEWED = 'Widget Viewed';
export const CHANGE_LOCATION = 'change location';
const CATEGORY_VIEWED = 'Vendor Category Viewed';

// sourceContent values
export const ARTICLES = 'articles';
export const CATEGORIES_LIST_VIEW = 'categories list view';
export const FOOTER = 'footer';
export const RECOMMENDED_VENDORS = 'recommended vendors';
export const SEARCH = 'search';

// selection values
export const START_TYPING = 'start typing';
export const SELECT_CATEGORY = 'select category';
export const OPEN_CATEGORY_MENU = 'open_category_menu';

// contentType values
const ARTICLE = 'article';

// sourceFormula values
export const BANDED_DISTANCE = 'banded distance';

// sourcePage values
export const CATEGORY_LANDING_PAGE = 'category landing page';
export const STATE_LANDING_PAGE = 'state landing page';
export const CATEGORY_RESULTS_PAGE = 'category results';
const SEMANTIC_RESULTS_PAGE = 'semantic_results';
const CITY_SEARCH_PAGE = 'city search page';
export const DEALS_LANDING_PAGE = 'deals landing page';

// page levels (AKA pageType)
export const AI_USAGE_POLICY = 'ai usage policy';
export const BEST_OF_WEDDINGS_LEVEL = 'best of weddings';
export const CATEGORY_LEVEL = 'category';
export const CITY_LEVEL = 'city';
export const DEALS_LEVEL = 'deals';
export const REVIEW_WEDDING_VENDORS_LEVEL = 'review wedding vendors';
export const STATE_LEVEL = 'state';
export const STOREFRONT_LEVEL = 'storefront';
export const PHOTOS_LEVEL = 'photos';

// base props
export const clickThroughToContentBaseProps = {
	contentType: ARTICLE,
	sourcePage: CATEGORY_LANDING_PAGE,
};

export const categoryViewed = (pageType, track, code, props) =>
	track({
		event: CATEGORY_VIEWED,
		properties: {
			vendorCategoryCode: code,
			vendorCategoryLevel: pageType,
			...props,
		},
	});

export const widgetViewed = (pageType, code) => ({
	event: WIDGET_VIEWED,
	properties: {
		sourceContent: RECOMMENDED_VENDORS,
		sourceFormula: BANDED_DISTANCE,
		sourcePage: pageType,
		vendorCategoryCode: code,
	},
});

// helpers
export const mapSourcePage = (pageType) => {
	switch (pageType) {
		case STATE_LEVEL:
			return STATE_LANDING_PAGE;
		case CATEGORY_LEVEL:
			return CATEGORY_LANDING_PAGE;
		case CITY_LEVEL:
			return CITY_SEARCH_PAGE;
		default:
			return CITY_SEARCH_PAGE;
	}
};

export const getSourcePageForContactVendor = (
	pageType,
	vendorPaid,
	isSemanticSearch,
) => {
	if (isSemanticSearch) {
		return SEMANTIC_RESULTS_PAGE;
	}

	switch (pageType) {
		case STOREFRONT_LEVEL:
			return `${vendorPaid} storefront`;
		case DEALS_LEVEL:
			return DEALS_LANDING_PAGE;
		default:
			return CATEGORY_RESULTS_PAGE;
	}
};
